import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { cellStyle, truncateStyle } from './constants';
export var TableBodyCell = styled.td(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " ", ";\n"], ["\n  ", " ", ";\n"])), function (props) { return truncateStyle(props); }, cellStyle);
var templateObject_1;
//# sourceMappingURL=TableCell.js.map